// extracted by mini-css-extract-plugin
module.exports = {"root":"_7EdR8","subTotal":"_3WIGC","totalSubLabel":"_2WQQy","disclaimer":"m8HfE"};